import {Component, OnInit, ViewChild} from '@angular/core';
import {Subject, Subscription} from "rxjs";
import {DataTableDirective} from "angular-datatables";
import {UserDataStoreService} from "../services/user-data-store.service";
import {ClientService} from "../services/client.service";

import {ClientViewModel} from "../models/client-view-model";
import {Router} from "@angular/router";
import { PermissionEnum } from '../services/guards/permissions';
import { ToastrService } from 'ngx-toastr';
import { SearchFilterModel } from '../models/search-filter-model';

@Component({
  selector: 'app-client-management',
  templateUrl: './client-management.component.html',
  styleUrls: ['./client-management.component.scss']
})
export class ClientManagementComponent implements OnInit {

  public dtOptions: DataTables.Settings = {};
  public clients: ClientViewModel[] = [];
  public dtTrigger: Subject<boolean> = new Subject();
  public canAdd: boolean;
  public canEdit: boolean;

  public filter: SearchFilterModel = {
    search: '',
    take: 10,
    skip: 0,
    orderBy: null,
    orderDirection: 'ASC'
  };

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;

  constructor(private _userDataStore: UserDataStoreService,
    private _clientService: ClientService,
    private _router: Router,
    private _toastService: ToastrService) {

    this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditClient], []);
    this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddClient], []);
  }

  ngOnInit() {
    this.dtOptions = {
      pageLength: this.filter.take,
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      ajax: async (dataTablesParameters: any, callback) => {
        this.filter.search = dataTablesParameters.search.value;
        this.filter.take = dataTablesParameters.length;
        this.filter.skip = dataTablesParameters.start;
        this.filter.orderDirection = dataTablesParameters.order[0].dir;
        this.filter.orderBy = dataTablesParameters.columns[dataTablesParameters.order[0].column].data;
        const result = await this._clientService.GetPagedClients(this.filter);
        this.clients = result.response;
        callback({
          recordsTotal: result.total,
          recordsFiltered: result.total,
          data: []
        });
      },
      responsive: true,
      columns: [
        { name: 'Client', data: 'Name' },
        { name:'Actions', data: 'actions', orderable: false }
      ]
    };
  }

  public async ngAfterViewInit(): Promise<void> {
    await this.init();
  }

  private async init(): Promise<void>{
    this.dtTrigger.next();
  }

  public async addClient(): Promise<void> {
    if (!this.canAdd) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      await this._router.navigate(['management/client', 'new']);
    }
    this.resetDatatable();
  }


  public async editClient(client: ClientViewModel): Promise<void> {
    if (!this.canEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      await this._router.navigate(['management/client', client.id]);
    }
    this.resetDatatable();
  }

  private resetDatatable(): void {
    this.clients = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

}
